


























import Vue from 'vue';
import { kebabCase } from 'lodash';
import { BDropdown, BDropdownItemButton } from 'bootstrap-vue';

import { updateObjectField } from '@/utils/crudActions';
import { objectStatusColor } from '@/utils';
import { DropdownOption } from '@/components/cards/types';

import { confirmObjectStatusChange } from './helpers';

export default Vue.extend({
  name: 'ObjectStatusDropdown',
  components: {
    BDropdown,
    BDropdownItemButton,
  },
  props: {
    currentValue: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
    objectId: {
      type: String,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
    },
    objectTitle: {
      type: String,
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      value: this.currentValue,
    };
  },
  computed: {
    statusColor(): string {
      let variant = objectStatusColor(this.value);

      if (['Request', 'Issue', 'Task'].includes(this.objectType) && variant) {
        const formattedObjectType = this.objectType.toLowerCase();
        const formattedValue = kebabCase(this.value);

        return `status-${formattedObjectType}-${formattedValue}`;
      }

      return variant ? variant : 'light';
    },
    divStatusColor(): string {
      return 'readonly btn btn-' + this.statusColor;
    },
  },
  methods: {
    async changeStatus(newStatus: string) {
      try {
        await updateObjectField({
          value: newStatus,
          ignoreWarnings: true,
          field: 'status',
          id: this.objectId,
          type: this.objectType,
          csrf: this.csrfToken,
          comment: '',
        });
        this.reload(newStatus);
      } catch (error) {
        window.GGRC.Notify({
          type: [error.type],
          message: error.message,
        });
      }
    },
    async confirmChange(newStatus: DropdownOption) {
      const currIdx = this.options.findIndex((i: DropdownOption) => i.value === this.value);
      const newIdx = this.options.findIndex((i: DropdownOption) => i.value === newStatus.value);

      if (await this.confirmObjectStatusChange(false, this.objectType, newStatus.value, currIdx > newIdx)) {
        this.changeStatus(newStatus.value);
      }
    },
    reload(status: string) {
      const msg = {
        type: 'success',
        message: `You have moved ${this.objectTitle} to ${status} status.`,
      };

      if (window.GGRC.zenModal.visible) {
        window.GGRC.zenModal.$emit('reload');
        window.GGRC.Notify(msg);
      } else {
        window.location.reload();
        window.GGRC.NotifyNextLoad(msg);
      }
    },
    confirmObjectStatusChange,
  },
});
